export default {
    validator: {
        required: 'จำเป็นต้องใส่ข้อมูล'
    },

    noData: 'ไม่มีข้อมูล',

    required: '<span class="red--text">*</span>',

    placeholder: {
        searchByBookingNo: 'Booking No.',
        filterByEmailAndName: 'ค้นหาจากอีเมล / ชื่อ - นามสกุลลูกค้า',
        filterByCustomerNameAndCreatedBy: 'Search by Customer Name / Create by',
        filterByCustonerName: 'Search by Customer Name',
        filterByNameAndContact: 'Search by Name / Contact Number',
        filterByStaffIDAndName: 'Search by ID / Staff Name',
        filterByMacAddressAndName: 'Search by Mac Address / iBeacon Name',
        filterByMessageIdAndTopic: 'Search by Message ID / Topic',
        filterBySaleNameEmailAndPhone: 'ค้นหาจาก ชื่อ - นามสกุลตัวแทนขาย / อีเมล / เบอร์โทรศัพท์',
        timeRange: 'จากเวลา ~ ถึงเวลา',
        dateTimeRange: 'จากวันที่  ~  ถึงวันที่',
        dateRange: 'จากวันที่  ~  ถึงวันที่',
        date: 'Click to select date',
        customerGroupSelect: 'Input customer name',
        nameAndLastName: 'Input name - lastname',
        contactNumber: 'Input contact number',
        username: 'Input username',
        password: 'Input password',
        confirmPassword: 'Input confirm password',
        customer: 'Input customer name',
        companyAddress: 'Input Company Address',
        province: 'Select province',
        phone: 'Input phone number',
        tax: 'Input tax identification number',
        address: 'Input address',
        contactName: 'Input contact name',
        googleMapLink: 'กรอก Google Map Link'
    },

    field: {
        geolocationMenuHeader: 'Google Map Link'
    },

    status: {
        active: 'Active',
        inactive: 'Inactive',
        all: 'All',
        approve: 'อนุมัติ',
        reject: 'ไม่อนุมัติ',
        waiting: 'รอตรวจสอบ',
        pending: 'ยังไม่จ่าย',
        paid: 'จ่ายแล้ว'
    },

    button: {
        sync: 'Sync',
        save: 'บันทึก',
        cancel: 'ยกเลิก',
        map: 'Map',
        close: 'ปิด',
        delete: 'Delete',
        create: 'Create',
        login: 'เข้าสู่ระบบ',
        logout: 'ลงชื่อออก',
        exportXlsx: 'Export .xlsx',
        createTicketVisibility: 'Create Visibility',
        createBanner: 'Create Banner',
        createEvent: 'Create Event',
        createCustomer: 'Create Customer',
        createStaff: 'Create Staff',
        createMessage: 'Create Message',
        viewMap: 'View Map',
        viewActivityHistory: 'View Activity History'
    },

    date: {
        addedYear: '543'
    },

    menu: {
        bookingList: 'Booking List',
        ticketAndAddOns: 'Tickets & Add-ons',
        andamandaPay: 'Andamanda Pay',
        ticketVisibility: 'Ticket Visibility',
        homepageSetting: 'Homepage Setting',
        topBanners: 'Top Banners',
        promotions: 'Promotions',
        ibeaconSetting: {
            title: 'ibeacon Setting',
            messages: 'Message',
            setting: 'Setting'
        },
        teamBuilding: {
            title: 'Team Building',
            events: 'Events',
            customer: 'Customer',
            participants: 'Participants',
            staff: 'Staff'
        },
        treasureHunt: 'Treasure Hunt',
        andamandaStaff: 'Andamanda Staff',
        saleAgentRequest: 'Request',
        saleAgent: {
            title: 'Sale Agent',
            byCategory: 'Sale agent list',
            byPersons: 'Sale by persons'
        },
        customerList: 'Customers'
    },

    treasure: {
        table: {
            order: 'No.',
            name: 'Part Name',
            geolocation: 'Lat, Long'
        }
    },

    treasureHunt: {
        header: 'Treasure Hunt',
        treasureHeader: 'Treasure',
        detail: {
            header: 'Edit Part',
            name: 'Part Name',
            geolocation: 'Lat, Long'
        }
    },

    bannerList: {
        table: {
            header: {
                settingDate: 'Setting Date',
                link: 'Url Link',
                banner: 'Banner',
                status: 'Status'
            }
        },
        details: {
            header: 'Edit Banners',
            isActive: 'Active',
            updatedAt: 'Last update',
            banner: 'Banner Image',
            link: 'Url Link'
        }
    },

    bookingList: {
        bookingHistory: 'Booking History',
        bookingDetails: {
            header: 'Booking Details',
            bookingNo: 'Booking No.',
            bookingDate: 'Booking Date',
            travelDate: 'Travel Date',
            sourceRef: 'Source Reference',
            firstName: 'ชื่อ',
            lastName: 'นามสกุล'
        },
        customerTab: 'Customer',
        saleAgentTab: 'Sale Agent',

        table: {
            header: {
                bookingNo: 'Booking No.',
                bookingDate: 'Booking Date',
                travelDate: 'Travel Date',
                firstName: 'ชื่อ',
                lastName: 'นามสกุล',
                items: 'Items',
                total: 'Total(THB)',
                saleAccount: 'Sale Account',
                quantity: 'Qty'
            }
        }
    },

    ticketAndAddOns: {
        productDetails: {
            header: 'Edit Product Details',
            productId: 'Product ID',
            productType: 'Product Type',
            productName: 'ชื่อสินค้า <span class="red--text">*</span>',
            price: 'ราคาจำหน่าย (THB)',
            description: 'คำอธิบายอย่างย่อ'
        },
        ticketHeader: 'Tickets',
        addOnHeader: 'Add-on Services',
        kabanaHeader: 'Kabana Services',
        productTable: {
            header: {
                productId: 'Product ID',
                ticketId: 'Ticket ID',
                productName: 'Product Name',
                description: 'Description',
                productType: 'Product Type',
                price: 'Price(THB)',
                amount: 'Amount',
                total: 'Total(THB)',
                status: 'Status'
            }
        }
    },

    ticketVisibility: {
        details: {
            header: 'Visibility Details',
            createdDate: 'วันที่สร้าง',
            latestChangedDate: 'การแก้ไขล่าสุด',
            type: 'ประเภทตั๋ว',
            visibilityType: 'ประเภทการแสดงผล',
            date: 'วันที่และเวลา'
        },
        visibilityType: {
            always: 'แสดงตลอด',
            'recurring-daily': 'แสดงทุกวันตามเงื่อนไข',
            'one-time': 'แสดงเพียงครั้งเดียว'
        },
        table: {
            header: {
                type: 'ประเภทตั๋ว',
                visibilityType: 'ประเภทการแสดงผล',
                date: 'วันที่และเวลา'
            }
        }
    },

    customerList: {
        header: 'Customer List',
        customerDetails: {
            header: 'Customer Account',
            lastestLoginDate: 'เข้าใช้งานล่าสุด',
            registerDate: 'วันที่ลงทะเบียน',
            registerBy: 'ลงทะเบียนโดย',
            customerId: 'Customer ID',
            email: 'อีเมล <span class="red--text">*</span>',
            firstName: 'ชื่อ',
            lastName: 'นามสกุล',
            nationality: 'สัญชาติ'
        },

        allNationality: 'ทุกสัญชาติ',
        table: {
            header: {
                customerId: 'Customer ID',
                firstName: 'ชื่อ',
                lastName: 'นามสกุล',
                email: 'อีเมล',
                nationality: 'สัญชาติ',
                registerDate: 'วันที่ลงทะเบียน',
                status: 'สถานะ'
            }
        }
    },

    eventList: {
        editHeader: 'Edit Event',
        createHeader: 'Create Event',
        qrHeader: 'QR Code',
        participantDetails: 'ผู้เข้าร่วม {amount} คน จำนวน {team} ทีม',
        eventDetails: {
            name: 'Customer Name',
            startDate: 'Start Date',
            participantAmount: 'Number of Participants',
            teamAmount: 'Number of Team',
            teamType: 'Team Type',
            status: 'Event Status',
            details: 'More details',
            dialog: {
                delete: {
                    header: 'Delete',
                    content: 'Are you sure you want to delete this event?<br>This action cannot be undo',
                    cancel: 'Cancel',
                    confirm: 'Yes, delete it!'
                }
            }
        },
        table: {
            header: {
                startDate: 'Start Date',
                customerName: 'Customer Name',
                member: 'Member',
                createdBy: 'Create By',
                status: 'Status'
            }
        }
    },

    customerGroupList: {
        details: {
            editHeader: 'Edit Customer',
            createHeader: 'Create Customer',
            name: 'Customer Name',
            addressInfo: 'Address Infomation',
            company: 'Company Address <span class="red--text">*</span>',
            province: 'Province',
            phone: 'Phone Number <span class="red--text">*</span>',
            tax: 'Tax Identification Number',
            delivery: 'Delivery Address',
            useCompany: 'Use Company Address',
            address: 'Address',
            contact: 'Contact',
            contactName: 'Contact Name',
            contactNumber: 'Contact Number'
        },
        dialog: {
            delete: {
                header: 'Delete',
                content: 'Are you sure you want to delete this customer?<br>This action cannot be undo',
                cancel: 'Cancel',
                confirm: 'Yes, delete it!'
            }
        },
        table: {
            header: {
                id: 'Customer ID',
                name: 'Customer Name',
                contact: 'Contact Name',
                phone: 'Contact Number'
            }
        }
    },

    participantList: {
        table: {
            header: {
                name: 'Name',
                phone: 'Contact Number',
                customer: 'Customer',
                registrationDate: 'Registration Date'
            }
        }
    },

    staffList: {
        details: {
            editHeader: 'Edit Staff',
            createHeader: 'Create Staff',
            name: 'Name - Lastname',
            phone: 'Contact Number',
            user: 'User Account',
            username: 'Username',
            password: 'Password',
            confirmPassword: 'Confirm Password',
            type: 'Staff Type',
            details: 'More Details'
        },

        dialog: {
            delete: {
                header: 'Delete',
                content: 'Are you sure you want to delete this staff?<br>This action cannot be undo',
                cancel: 'Cancel',
                confirm: 'Yes, delete it!'
            }
        },

        table: {
            header: {
                id: 'Staff ID',
                name: 'Staff Name',
                role: ''
            }
        }
    },

    ibeaconMessage: {
        header: 'Message',

        createHeader: 'Create Message',

        table: {
            header: {
                id: 'Message ID',
                title: 'Topic',
                effectiveDates: 'Message Date'
            }
        },

        details: {
            id: 'Message ID',
            effectiveDates: 'Message Date',
            messageDetails: 'Message Details',
            image: 'Image',
            title: 'Topic',
            subtitle: 'Description',
            condition: 'Condition'
        },

        dialog: {
            delete: {
                header: 'Delete',
                content: 'Are you sure you want to delete this message?<br>This action cannot be undo',
                cancel: 'Cancel',
                confirm: 'Yes, delete it!'
            }
        }
    },

    ibeacon: {
        table: {
            major: 'Major',
            minor: 'Minor',
            uuid: 'UUID',
            macAddress: 'Mac Address',
            message: 'Message'
        },

        map: 'Map',

        editHeader: 'IBeacon',

        details: {
            macAddress: 'Mac Address',
            name: 'IBeacon Name',
            uuid: 'UUID',
            major: 'Major',
            minor: 'Minor',
            remark: 'Remark',
            broadcastMessage: 'Broadcasting Message',
            message: 'Message'
        }
    },

    saleAgent: {
        table: {
            requestDate: 'วันที่ส่งคำขอ',
            saleId: 'Sale ID',
            staffId: 'Staff ID',
            name: 'ชื่อ - นามสกุล',
            company: 'บริษัท / องค์กร',
            email: 'อีเมล',
            phone: 'เบอร์โทรศัพท์',
            type: 'ประเภทตัวแทนขาย',
            approveStatus: 'การอนุมัติ',
            status: 'สถานะ',
            ticketAmount: 'จำนวนบัตร',
            saleTotal: 'ยอดขายรวม (บาท)',
            allCommission: 'ยอด Comission (บาท)'
        },

        historyTable: {
            bookingNo: 'Booking No.',
            staff: 'Staff',
            tourist: 'Tourists',
            total: 'Total (THB)',
            commission: 'Commission (THB)'
        },

        details: {
            id: 'หมายเลขผู้แทนจำหน่าย',
            requestDate: 'วันที่ลงทะเบียน',
            type: 'ประเภทผู้ใช้',
            agentType: 'ประเภทตัวแทนขาย',
            name: 'ชื่อ - นามสกุล',
            passportId: 'เลขบัตรประจำตัวประชาชน 13 หลัก',
            carId: 'หมายเลขทะเบียนรถ (ถ้ามี)',
            company: 'บริษัท / องค์กร (ถ้ามี)',
            phone: 'เบอร์โทรศัพท์',
            email: 'อีเมล',
            passportIdImage: 'ภาพบัตรประชาชน หรือ ใบอนุญาติขับรถ',
            commission: 'commission',
            bookbankName: 'Bank name',
            bookbankNo: 'Bookbank No.'
        },

        requestDetails: 'Sale Agent Request',
        saleAgentByCategoryDetails: 'Sale Agent Infomation',
        saleAgentByPersonDetails: 'ข้อมูลบัญชี',
        andamandaStaffDetails: 'Staff Infomation'
    },

    andamandaPay: {
        pocketId: 'Pocket ID',
        wristbandId: 'Wristband ID',

        pocketDetails: {
            header: 'Pocket Transaction History',
            pocketId: 'Pocket ID',
            activationDate: 'Activation Date',
            customerId: 'Customer ID',
            firstName: 'ชื่อ',
            lastName: 'นามสกุล',
            customerEmail: 'Email',
            nationality: 'Nationality',
            currentBalance: 'Current Balance (Coin)',
            transactionHeader: 'Transaction'
        },

        wristbandDetails: {
            header: 'Wristband Transaction History',
            wristbandId: 'Wristband ID',
            activationDate: 'Activation Date',
            currentBalance: 'Current Balance (Coin)',
            transactionHeader: 'Transaction'
        },

        transactionTable: {
            header: {
                refNo: 'Ref No.',
                date: 'Date',
                detail: 'Detail',
                amount: 'Amount'
            }
        },

        pocketTable: {
            header: {
                pocketId: 'Pocket ID',
                firstName: 'ขื่อ',
                lastName: 'นามสกุล',
                activationDate: 'Activation Date',
                currentBalance: 'Current Balance'
            }
        },

        wristbandTable: {
            header: {
                wristbandId: 'Wristband ID',
                wristbandName: 'Wristband Name',
                activationDate: 'Activation Date',
                currentBalance: 'Current Balance'
            }
        }
    },

    andamandaStaff: {
        header: 'Andamanada Staff'
    },

    saleAgentByCategory: {
        header: 'Sale Agent List'
    },

    saleAgentByPerson: {
        header: 'Sale by Person'
    }
}
